<template>
    <div class="container container-no-padding">
        <h3 class="title section-title-26 text-c" v-if="!$store.state.inClientAdmin">{{ $helper.trans('Choose_most_suitable_way_for_you_to_send_package') }}</h3>
        <div class="steps-block" v-if="!$store.state.inClientAdmin">
            <!--Steps line-->
            <ul class="steps steps-6">
                <li class="success-step">
                    <span class="step-label">{{ $helper.trans('Order_submission') }}</span>
                </li>
                <li class="success-step">
                    <span class="step-label">{{ $helper.trans('Shipping_address') }}</span>
                </li>
                <li class="success-step">
                    <span class="step-label">{{ $helper.trans('Receiving_address') }}</span>
                </li>
                <li class="success-step">
                    <span class="step-label">{{ $helper.trans('Shipment_information') }}</span>
                </li>
                <li class="success-step">
                    <span class="step-label">{{ ($store.state.transportationType === 'export') ? $helper.trans('Courier_call') : $helper.trans('Label_presenting') }}</span>
                </li>
                <li class="active-step">
                    <span class="step-label">{{ $helper.trans('Payment') }}</span>
                </li>
            </ul>
        </div>
        <!--End steps line-->
        <div class="content-wrap">
            <!--Wrap content-->
            <div class="payment-top" id="shipping_information_block">
                <div class="attention-block" v-if="!$store.state.inClientAdmin && $store.state.$siteSettings.customer_payment_type !== 'all'">
                    {{ $helper.trans('Please_check_shipment_details_carefully') }}                    
                </div>
                <div class="payment-two-column-block">
                    <div class="column-6 info-about-packet">
                        <div class="accordion">
                            <div class="accordion-item">
                                <h2 class="accordion-header">
                                    <button class="accordion-button">{{ $helper.trans('Shipment_information') }}</button>
                                </h2>
                                <div class="accordion-collapse collapse" style="display: initial;">
                                    <div class="accordion-body">
                                        <div class="packet-box-info" v-if="$store.state.selectedFormType === 'single'">
                                            <span class="packet-info-label mb-2">
                                                <strong>{{ $helper.trans('Total_packages') }}:</strong> {{ $store.state.packagesDimensions.length }}
                                            </span>
                                            <span class="packet-title" v-for="(packagesDimension, packageIndex) in $store.state.packagesDimensions" :key="packageIndex">
                                                {{ ($store.state.packagesDimensions.length > 1 ? (packageIndex +1) : '') }} {{ packageTypeName }} {{ packageLineDimensions(packagesDimension) }}
                                            </span> 
                                            <span class="packet-info-label">
                                                <strong>{{ $helper.trans('Service') }}: </strong>{{ $store.state.selectedShippingOption.serviceName }}
                                            </span>
                                            <span class="packet-info-label">
                                                <strong>{{ isImport ? $helper.trans('Give_until') : $helper.trans('Item_pickup') }}: </strong>{{ calculatedPickupTime }}
                                            </span>
                                            <span class="packet-info-label">
                                                <strong>{{ $helper.trans('Delivery') }}: </strong>{{ formattedDeliveryTime }}
                                            </span>
                                        </div>
                                        <div v-if="$store.state.selectedFormType === 'mass'">
                                            <div v-show="$store.state.massShipments.length > 2">
                                                <button 
                                                    v-show="!massShipmentsPacketsSummary" 
                                                    class="btn show-detalization-button" 
                                                    @click="showHideMassShipmentsPacketsSummary('show');"
                                                >
                                                    {{ $helper.trans('Show_every_packet_summary') }}
                                                </button>
                                                <button 
                                                    v-show="massShipmentsPacketsSummary"
                                                    class="btn show-detalization-button" 
                                                    @click="showHideMassShipmentsPacketsSummary('hide');"
                                                >
                                                    {{ $helper.trans('Hide_every_packet_summary') }}
                                                </button>                                           
                                            </div>
                                            <div class="packet-box-info mb-5" v-for="(shipment, shipmentIndex) in $store.state.massShipments" :key="shipmentIndex"> 
                                                <div v-show="checkMassShipmentsPacketsSummaryVisibility(shipmentIndex)">
                                                    <span class="packet-info-label mb-4">
                                                        <strong>{{ $helper.trans('Total_packages') }}: </strong> {{ shipment.PackagesNum }}
                                                    </span>
                                                    <b class="d-inline mr-2">{{ shipmentIndex + 1 }}.</b>
                                                    <span class="d-inline packet-title">
                                                        {{ shipment.PackagesNum }} {{ shipment.PackageName }} {{ packageLineDimensions($helper.getDimensionsToMassShipments(shipment)) }}
                                                    </span> 
                                                    <span class="packet-info-label">
                                                        <strong>{{ $helper.trans('Service') }}: </strong>{{ shipment.ServiceName }}
                                                    </span>
                                                    <span class="packet-info-label">
                                                        <strong>{{ isImport ? $helper.trans('Give_until') : $helper.trans('Item_pickup') }}: </strong>{{ getCalculatedPickupTime(shipment) }}
                                                    </span>
                                                    <span class="packet-info-label">
                                                        <strong>{{ $helper.trans('Delivery') }}: </strong>{{ getFormattedDeliveryTime(shipment) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-100">
                                            <div class="voucher-block" v-if="$store.state.majorPaymentType === 'prepaid'">
                                                <input 
                                                    type="text" 
                                                    name="voucher_code" 
                                                    :placeholder="$helper.trans('Enter_discount_code')" 
                                                    class="input-big"
                                                    @change="checkDiscount();"
                                                    v-model="$store.state.voucherCode"
                                                />
                                                <button class="btn-arrow" @click="checkDiscount();"></button>
                                            </div>
                                            <span v-show="wrongDiscountCode" class="ups-danger-text mt-2 ml-2">
                                                {{ $helper.trans('Wrong_or_expired_discount_code') }}
                                            </span>
                                            <span v-show="discountCodeDoesNotApply" class="mt-2 ml-2">
                                                {{ $helper.trans('Discount_code_does_not_apply_to_this_shipment') }}
                                            </span>                                            
                                        </div>
                                        <div class="w-100" v-if="!$store.state.inClientAdmin && $store.state.majorPaymentType === 'prepaid'">
                                            <span style="font-size:10px;">                                                
                                                {{ $helper.trans('Discount_applies_only_on_prepaid_clients') }}
                                            </span>
                                        </div>
                                        <div class="price-option-line mt-3" v-if="$store.state.currentActions.gettingShippingOptions">
                                            {{ $helper.trans('Check_discount_by_voucher_code') }}
                                            <i class="fa fa-cog fa-spin fa-2x ml-2"></i>
                                        </div>                                       
                                    </div>                      
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column-6 payment-info">
                        <div v-if="$store.state.selectedFormType === 'mass'">
                            <span class="mass-shipments-summary" v-show="!massShipmentsAmountSummary" 
                                @click="showHideMassShipmentsAmountsSummary('show')"
                            >
                                {{ $helper.trans('Show_every_order_summary') }}
                            </span>
                            <span class="mass-shipments-summary" v-show="massShipmentsAmountSummary" 
                                @click="showHideMassShipmentsAmountsSummary('hide')"
                            >
                                {{ $helper.trans('Hide_every_order_summary') }}
                            </span>
                            <div v-if="$store.state.selectedFormType === 'mass'" style="border-top: 3px solid rgba(247, 246, 245, 0.1);margin-top: 15px;"></div>
                            <div v-show="massShipmentsAmountSummary" class="payment-block pt-2 pb-3" v-for="(shipment, shipmentIndex) in $store.state.massShipmentsDetailedCosts" :key="shipmentIndex">
                                <b class="d-inline mr-2" style="color:#FFF;">{{ shipmentIndex + 1 }}.</b> 
                                <div class="payment-row ">
                                    <label class="item">{{ $helper.trans('Transporting') }}</label>
                                    <span class="value">{{ shipment.baseCost }}€</span>
                                </div>                    
                                <div class="payment-row payment-line pb-0" v-if="transportPayerText === false">
                                    <label class="item">{{ $helper.trans('Fuel_surcharge') }}</label>
                                    <span class="value">
                                        {{ shipment.fuelCharges }}€
                                    </span>
                                </div>   
                                <div class="payment-row payment-small-text payment-line pb-0" 
                                    v-for="(charge, chargeIndex) in shipment.otherCharges"
                                    :key="chargeIndex"
                                >
                                    <label class="item">{{ charge.name }}</label>
                                    <span class="value">{{ parseFloat(charge.amount).toFixed(2) }}€</span>
                                </div>                   
                                <div class="payment-row">
                                    <label class="item">{{ $helper.trans('Price') }}</label>
                                    <span class="value">{{ shipment.totalCost }}€</span>
                                </div>
                                <div class="payment-row payment-line pb-0">
                                    <label class="item">{{ $helper.trans('VAT') }}</label>
                                    <span class="value">
                                        {{ shipment.vat }}€
                                    </span>
                                </div>
                                <div class="payment-block payment-line pb-0">
                                    <div class="payment-row">
                                        <label class="item">{{ $helper.trans('Total') }}</label>
                                        <span class="value">{{ shipment.totalCostWithVat }}€</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-show="massShipmentsAmountSummary" v-if="$store.state.selectedFormType === 'mass'" style="border-top: 3px solid rgba(247, 246, 245, 0.1);margin-top: 15px;"></div>
                        <div class="payment-block payment-line mt-5">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('Transporting') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.baseCost).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row" v-if="transportPayerText">
                                <label class="item">{{ transportPayerText }}</label>
                                <span class="value"></span>
                            </div>
                            <div class="payment-row" v-if="transportPayerText === false">
                                <label class="item">{{ $helper.trans('Fuel_surcharge') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.fuelCharges).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row" v-if="$store.state.majorPaymentType === 'prepaid' && $store.state.detailedCosts.exportDeclarationCharge > 0">
                                <label class="item">{{ $helper.trans('Export_declaration') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.exportDeclarationCharge).toFixed(2) }}€</span>
                            </div>
                        </div>
                        <div class="payment-block payment-line">
                            <div class="payment-row payment-small-text" 
                                v-for="(charge, chargeIndex) in $store.state.detailedCosts.otherCharges"
                                :key="chargeIndex"
                            >
                                <label class="item">{{ charge.name }}</label>
                                <span class="value">{{ parseFloat(charge.amount).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row payment-small-text" v-if="taxPayerText">
                                <label class="item">{{ taxPayerText }}</label>
                                <span class="value"></span>
                            </div>
                        </div>
                        <div class="payment-block">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('Price') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.totalCost).toFixed(2) }}€</span>
                            </div>
                            <div class="payment-row payment-line">
                                <label class="item">{{ $helper.trans('VAT') }}</label>
                                <span class="value">{{ parseFloat($store.state.detailedCosts.vat).toFixed(2) }}€</span>
                            </div>
                        </div>
                        <div class="payment-block payment-total-block">
                            <div class="payment-row">
                                <label class="item">{{ $helper.trans('In_all') }}</label>
                                <span class="value">
                                    {{ parseFloat($store.state.detailedCosts.totalCostWithVat).toFixed(2) }}€
                                    <del style="font-size: 13px;" v-show="oldPrice > 0">{{ parseFloat(oldPrice).toFixed(2) }}€</del>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
            <div class="payment-accordion-wrap">
                <div class="accordion">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button">
                                {{ $helper.trans('Addresses') }}
                            </button>
                        </h2>
                        <div class="accordion-collapse collapse" style="display: initial">
                            <div class="accordion-body">
                                <div class="row w-100">
                                    <div class="col-12 col-md-6">
                                        <label class="strong-label">{{ $helper.trans('Sender') }}</label>
                                        <div class="final-address-info">
                                            <label>{{ $helper.trans('Company_or_firstname_lastname') }}: <span>{{ $store.state.shipperAddressInformation.companyOrSender }}</span></label>
                                            <label>{{ $helper.trans('Contact_person') }}: <span>{{ $store.state.shipperAddressInformation.contactPerson }}</span></label>
                                            <label>{{ $helper.trans('Phone_number') }}: <span>{{ $store.state.shipperAddressInformation.phone }}</span></label>
                                            <label>{{ $helper.trans('Contact_email') }}: <span>{{ $store.state.shipperAddressInformation.email }}</span></label>
                                            <label>{{ $helper.trans('Address') }}: <span>{{ fullShipperAddress }}</span></label>
                                            <label>{{ $helper.trans('Zip_code') }}: <span>{{ $store.state.from.country.toUpperCase() }}-{{ $store.state.from.postCode }}</span></label>
                                            <label>{{ $helper.trans('City') }}: <span>{{ $store.state.shipperAddressInformation.city }}</span></label>
                                            <label>{{ $helper.trans('Country') }}: <span>{{ $store.state.from.countryName }}</span></label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6" v-if="$store.state.selectedFormType === 'single'">
                                        <label class="strong-label">{{ $helper.trans('Receiver') }}</label>
                                        <div class="final-address-info">
                                            <label>{{ $helper.trans('Company_or_firstname_lastname') }}: <span>{{ $store.state.deliveryAddressInformation.companyOrSender }}</span></label>
                                            <label>{{ $helper.trans('Contact_person') }}: <span>{{ $store.state.deliveryAddressInformation.contactPerson }}</span></label>
                                            <label>{{ $helper.trans('Phone_number') }}: <span>{{ $store.state.deliveryAddressInformation.phone }}</span></label>
                                            <label>{{ $helper.trans('Contact_email') }}: <span>{{ $store.state.deliveryAddressInformation.email }}</span></label>
                                            <label>{{ $helper.trans('Address') }}: <span>{{ fullDeliveryAddress }}</span></label>
                                            <label>{{ $helper.trans('Zip_code') }}: <span>{{ $store.state.to.country.toUpperCase() }}-{{ $store.state.to.postCode }}</span></label>
                                            <label>{{ $helper.trans('City') }}: <span>{{ $store.state.deliveryAddressInformation.city }}</span></label>
                                            <label>{{ $helper.trans('Country') }}: <span>{{ $store.state.to.countryName }}</span></label>
                                        </div>
                                    </div> 
                                    <div class="col-12 col-md-6" v-if="$store.state.selectedFormType === 'mass'">                                
                                        <div class="row">
                                            <div class="col-12">
                                                <label class="strong-label">{{ $helper.trans('Receivers') }}</label>
                                                <div v-show="$store.state.massShipments.length > 2" style="margin-top:-50px;">
                                                    <button 
                                                        v-show="!massShipmentsAddressesSummary" 
                                                        class="btn show-detalization-button mass-shipments-address-summary" 
                                                        @click="showHideMassShipmentsAddressSummary('show');"
                                                    >
                                                        {{ $helper.trans('Show_every_address_summary') }}
                                                    </button>
                                                    <button 
                                                        v-show="massShipmentsAddressesSummary"
                                                        class="btn show-detalization-button mass-shipments-address-summary" 
                                                        @click="showHideMassShipmentsAddressSummary('hide');"
                                                    >
                                                        {{ $helper.trans('Hide_every_address_summary') }}
                                                    </button>
                                                </div>
                                            </div>                                   
                                            <div class="final-address-info mr-4 mb-4" v-for="(shipment, shipmentIndex) in $store.state.massShipments" :key="shipmentIndex">
                                                <div v-show="checkMassShipmentsAddressesSummaryVisibility(shipmentIndex)">
                                                    <b>{{ shipmentIndex + 1 }}.</b>
                                                    <label>
                                                        {{ $helper.trans('Company_or_firstname_lastname') }}: <span>{{ shipment.Company }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Contact_person') }}: <span>{{ shipment.Contact }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Phone_number') }}: <span>{{ shipment.Phone }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Contact_email') }}: <span>{{ shipment.Email }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Address') }}: <span>{{ getFullDeliveryAddress(shipment) }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Zip_code') }}: <span>{{ shipment.Country.toUpperCase() }}-{{ shipment.PostCode }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('City') }}: <span>{{ shipment.City }}</span>
                                                    </label>
                                                    <label>
                                                        {{ $helper.trans('Country') }}: <span>{{ shipment.CountryName }}</span>
                                                    </label>
                                                </div>
                                            </div>  
                                        </div>                               
                                    </div>
                                    <div class="col-12 mt-4" v-if="$store.state.carrierInfo.differentAddress">                
                                        <span class="packet-info-label">
                                            <strong>{{ $helper.trans('Shipment_pickup_address') }}: </strong>
                                            {{ $store.state.carrierInfo.differentAddressInfo.address1 }},
                                            {{ $store.state.carrierInfo.differentAddressInfo.city }},
                                            {{ $store.state.carrierInfo.differentAddressInfo.postCode }},
                                            {{ $store.state.carrierInfo.differentAddressInfo.phone }}
                                        </span>                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion" v-if="!$store.state.$siteSettings['Logged_in']">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button">
                                {{ $helper.trans('Unregistered_invoice') }}
                            </button>
                        </h2>
                        <div class="accordion-collapse collapse" style="display: initial">
                            <div class="accordion-body">
                                <div class="row w-100">
                                    <div class="col-12">
                                        <div style="display: flex;">
                                            <label for="radio-1" class="custom-radio-wrap mr-2" style="min-width: 150px;">
                                                {{ $helper.trans('Unregistered_invoice_physical_person') }}
                                                <input type="radio" @click="clickUnregisteredCompanyInformationRadio('person');" v-model="$store.state.unregisteredCompanyInformation.type" class="unregisteredCompanyInformation_type_input" value="person" id="radio-1">
                                                <span class="checkmark"></span>
                                            </label>
                                            <label for="radio-2" class="custom-radio-wrap mr-2" style="min-width: 150px;">
                                                {{ $helper.trans('Unregistered_invoice_company') }}
                                                <input type="radio" @click="clickUnregisteredCompanyInformationRadio('company');" v-model="$store.state.unregisteredCompanyInformation.type" value="company" id="radio-2">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.companyCode" :placeholder="'* '+$helper.trans('Company_code')" class="input-big w-100 unregisteredCompanyInformation_company_companyCode_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.registrationAddress" :placeholder="'* '+$helper.trans('Registration_address')" class="input-big w-100 unregisteredCompanyInformation_company_registrationAddress_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.vatCode" :placeholder="$helper.trans('VAT_code')" class="input-big w-100 unregisteredCompanyInformation_company_vatCode_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.city" :placeholder="'* '+$helper.trans('City')" class="input-big w-100 unregisteredCompanyInformation_company_city_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <select2-component :values="$store.state.$siteSettings['common_company_types']"
                                                           :value="$store.state.unregisteredCompanyInformation.company.type"
                                                           :placeholder="'* '+$helper.trans('Company_type')"
                                                           drop-down-class="select2-with-search"
                                                           classes="input-big w-100 unregisteredCompanyInformation_company_type_input"
                                                           allow-new-options
                                                           no-lang
                                                           @input="(value) => $store.state.unregisteredCompanyInformation.company.type = value.toString().toUpperCase()"
                                        />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.postCode" :placeholder="'* '+$helper.trans('Post_code')" class="input-big w-100 unregisteredCompanyInformation_company_postCode_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.companyName" :placeholder="'* '+$helper.trans('Company_name')" class="input-big w-100 unregisteredCompanyInformation_company_companyName_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'company'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.company.emailAddress" :placeholder="'* '+$helper.trans('Contact_email')" class="input-big w-100 unregisteredCompanyInformation_company_emailAddress_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'person'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.person.contactPerson" :placeholder="'* '+$helper.trans('Contact_person')" class="input-big w-100 unregisteredCompanyInformation_person_contactPerson_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'person'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.person.address" :placeholder="'* '+$helper.trans('Address')" class="input-big w-100 unregisteredCompanyInformation_person_address_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'person'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.person.emailAddress" :placeholder="'* '+$helper.trans('Contact_email')" class="input-big w-100 unregisteredCompanyInformation_person_emailAddress_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'person'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.person.postCode" :placeholder="'* '+$helper.trans('Post_code')" class="input-big w-100 unregisteredCompanyInformation_person_postCode_input" />
                                    </div>
                                    <div class="col-12 col-md-6 mt-2" v-if="$store.state.unregisteredCompanyInformation.type === 'person'">
                                        <input type="text" v-model="$store.state.unregisteredCompanyInformation.person.city" :placeholder="$helper.trans('City')" class="input-big w-100 unregisteredCompanyInformation_person_city_input" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="accordion" v-if="$store.state.majorPaymentType === 'prepaid'">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button">
                                {{ $helper.trans('Payment_methods') }}
                            </button>
                        </h2>
                        <div class="accordion-collapse collapse" style="display: initial;">
                            <div class="accordion-body pt-4">
                                <div class="payment-ways-content">
                                    <div class="payment-option-row">                           
                                        <div class="payment-option">
                                            <ul class="list-payment">
                                                <li>
                                                    <label for="e-bank-seb" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'vb2'}" v-model="$store.state.paymentOption" value="vb2" id="e-bank-seb">
                                                        <span class="bank-logo bank-seb"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-swedbank" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'hanza'}" v-model="$store.state.paymentOption" value="hanza" id="e-bank-swedbank">
                                                        <span class="bank-logo bank-swedbank"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-luminor" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'nord'}" v-model="$store.state.paymentOption" value="nord" id="e-bank-luminor">
                                                        <span class="bank-logo bank-luminor"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-revolut" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'lt_revolut'}" v-model="$store.state.paymentOption" value="lt_revolut" id="e-bank-revolut">
                                                        <span class="bank-logo bank-revolut"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-med-bankas" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'mb'}" v-model="$store.state.paymentOption" value="mb" id="e-bank-med-bankas">
                                                        <span class="bank-logo bank-med-bankas"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-lku-unija" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'lku'}" v-model="$store.state.paymentOption" value="lku" id="e-bank-lku-unija">
                                                        <span class="bank-logo bank-lku-unija"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-citadele" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'parex'}" v-model="$store.state.paymentOption" value="parex" id="e-bank-citadele">
                                                        <span class="bank-logo bank-citadele"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-siauliu" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'sb'}" v-model="$store.state.paymentOption" value="sb" id="e-bank-siauliu">
                                                        <span class="bank-logo bank-siauliu"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-bank-n26" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'lt_n26'}" v-model="$store.state.paymentOption" value="lt_n26" id="e-bank-n26">
                                                        <span class="bank-logo bank-n26"></span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label for="e-money-paysera" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'wallet'}" v-model="$store.state.paymentOption" value="wallet" id="e-money-paysera">
                                                        <span class="bank-logo bank-paysera"></span>
                                                    </label>
                                                </li>
                                                <li v-if="$store.state.detailedCosts.totalCostWithVat < 1001">
                                                    <label for="card-mastercard" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'card1'}" v-model="$store.state.paymentOption" value="card1" id="card-mastercard">
                                                        <span class="bank-logo bank-mastercard"></span>
                                                    </label>
                                                </li>
                                                <li v-if="$store.state.detailedCosts.totalCostWithVat < 1001">
                                                    <label for="card-visa" class="payment-name-option">
                                                        <input type="radio" :class="{'checked': $store.state.paymentOption === 'card2'}" v-model="$store.state.paymentOption" value="card2" id="card-visa">
                                                        <span class="bank-logo bank-visa"></span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>     
                            </div>
                        </div>
                    </div>
                </div>
                <div class="send-block button-block payment-block-confirm">
                    <div class="agree-condition-block" v-if="$store.state.$siteSettings.customer_payment_type !== 'all'">
                        <label for="payment-condition" class="custom-checkbox-wrap" :class="{'text-black': $store.state.inClientAdmin}">
                            {{ $helper.trans('I_have_read_and_agree_to') }}
                            <a target="_blank" :href="$store.state.$siteSettings['Terms_and_conditions_url']">{{ $helper.trans('terms_and_conditions') }}</a>  
                            <a target="_blank" :href="$store.state.$siteSettings['Privacy_policy_url']">{{ $helper.trans('privacy_policy') }}</a>
                            <a href="javascript:void(0);" data-toggle="modal" data-target="#packing_modal"> {{ $helper.trans('packaging_recommendations') }},</a>   
                            <a :href="$store.state.$siteSettings['Mt_sutartis_url']">{{ $helper.trans('agree_with_mt_conditions') }}</a>  
                            
                            <input type="checkbox" v-model="paymentAgreeCondition" name="payment_agree_condition" id="payment-condition" :value="1">
                            <span class="checkmark"></span>
                        </label>
                        <span class="ups-danger-text" v-if="termsAndConditionsError">{{ $helper.trans('You_must_agree_to_the_terms_and_conditions') }}</span>

                        <label for="transport_cost" class="custom-checkbox-wrap" :class="{'text-black': $store.state.inClientAdmin}">
                            {{ $helper.trans('I_understand_that_the_cost_of_transportation_may_vary') }}  
                            <input type="checkbox" v-model="paymentAgreeTransportationCost" name="payment_agree_transportation_cost" id="transport_cost" :value="1">
                            <span class="checkmark"></span>
                        </label>
                        <span class="ups-danger-text" v-if="transportCostsCheckError">{{ $helper.trans('You_must_check_transportation_cost') }}</span>                        
                    </div>
                    <button @click="backStep();" class="btn btn-border radius-4">{{ $helper.trans('Back') }}</button>
                    <button @click="toPayment();" class="btn btn-yellow radius-4" :disabled="requestInProgress">
                        <i v-if="requestInProgress" class="fa fa-spinner fa-spin"></i>
                        {{ ($store.state.majorPaymentType === 'prepaid') ? $helper.trans('Pay') : $helper.trans('Confirm') }}
                    </button>
                </div>
            </div>
        </div>

        <div class="modal fade pr-0" id="packing_modal" tabindex="-1" role="dialog" aria-labelledby="packing_modal_label" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content mb-1">
                    <div class="modal-header">
                        <div class="example-modal-header">
                            <span class="count">1</span>
                            {{ $helper.trans('Outer_packaging') }}
                        </div>                      
                    </div>
                    <div class="modal-body" v-html="$store.state.$siteSettings['Outer_packaging']"></div>   
                </div>
                <div class="modal-content mb-1">
                    <div class="modal-header">              
                        <div class="example-modal-header">
                            <span class="count">2</span>
                                {{ $helper.trans('Inner_packing') }}
                            </div>      
                        </div>
                    <div class="modal-body" v-html="$store.state.$siteSettings['Inner_packing']"></div>                  
                </div>
                 <div class="modal-content">
                    <div class="modal-header">              
                        <div class="example-modal-header">
                            <span class="count">3</span>
                                {{ $helper.trans('Additional_comments_on_packaging') }}
                            </div>      
                        </div>
                    <div class="modal-body" v-html="$store.state.$siteSettings['Additional_comments_on_packaging']"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-warning" data-dismiss="modal">
                            {{ $helper.trans('Close') }}
                        </button>                      
                    </div>
                </div>
            </div>
        </div>   
    </div>
</template>

<script>
import store from "../../../store";
import sha256 from 'crypto-js/sha256';
import Select2Component from "../common_components/Select2Component.vue";

export default {
  components: {Select2Component},
    store,
    data: function(){
        return {           
            paymentAgreeCondition: 0,
            paymentAgreeTransportationCost: 0,
            requestInProgress: false,
            transportCostsCheckError: false,
            termsAndConditionsError: false,
            wrongDiscountCode: false,
            discountCodeDoesNotApply: false,
            needRestoreOldAmounts: false,
            oldPrice: 0,
            massShipmentsPacketsSummary: false,
            massShipmentsAddressesSummary: false,
            massShipmentsAmountSummary: false,
        };
    },
    created: function(){    
        if(!this.$store.state.$siteSettings['Logged_in'] && this.isImport){
            this.$store.state.unregisteredCompanyInformation.person.contactPerson = this.$store.state.deliveryAddressInformation.contactPerson;
            this.$store.state.unregisteredCompanyInformation.person.address = this.$store.state.deliveryAddressInformation.address1;
            this.$store.state.unregisteredCompanyInformation.person.city = this.$store.state.deliveryAddressInformation.city;
            this.$store.state.unregisteredCompanyInformation.person.postCode = this.$store.state.to.postCode;
            this.$store.state.unregisteredCompanyInformation.person.emailAddress = this.$store.state.deliveryAddressInformation.email;
        } else if(!this.$store.state.$siteSettings['Logged_in'] && !this.isImport){
            this.$store.state.unregisteredCompanyInformation.person.contactPerson = this.$store.state.shipperAddressInformation.contactPerson;
            this.$store.state.unregisteredCompanyInformation.person.address = this.$store.state.shipperAddressInformation.address1;
            this.$store.state.unregisteredCompanyInformation.person.city = this.$store.state.shipperAddressInformation.city;
            this.$store.state.unregisteredCompanyInformation.person.postCode = this.$store.state.from.postCode;
            this.$store.state.unregisteredCompanyInformation.person.emailAddress = this.$store.state.shipperAddressInformation.email;
        }
    },
    methods: {
        showHideMassShipmentsAmountsSummary: function(type) {
            if (type === 'show') {
                this.massShipmentsAmountSummary = true;
                return
            }

            this.massShipmentsAmountSummary = false;
        },
        checkMassShipmentsPacketsSummaryVisibility: function(index) {
            if (index === 0) {
                return true;
            }

            return this.massShipmentsPacketsSummary;
        },
        showHideMassShipmentsPacketsSummary: function(type) {
            if (type === 'show') {
                this.massShipmentsPacketsSummary = true;
                return
            }

            this.massShipmentsPacketsSummary = false;
        },
        checkMassShipmentsAddressesSummaryVisibility: function(index) {
            if (index === 0 || index === 1) {
                return true;
            }

            return this.massShipmentsAddressesSummary;
        },
        showHideMassShipmentsAddressSummary: function(type) {
            if (type === 'show') {
                this.massShipmentsAddressesSummary = true;
                return
            }

            this.massShipmentsAddressesSummary = false;
        },
        backStep: function(){
            this.$store.state.checkOutSteps.seven = false;
            this.$store.state.returnedBackFromPayment = true;
            this.$store.state.calculatorState = 'shippingInformationForm';
        },      
        toPayment: async function() {
            $('#toast_container').html('');
            let vueThis = this;
            
            vueThis.$store.state.checkSession = false;            

            if (vueThis.$store.state.carrierInfo.callCarrier === 1) {
                let [hours, minutes] = vueThis.$store.state.pickupInformation.latestOrderTime.split(":").map(Number);

                let carrierDate = new Date(vueThis.$store.state.carrierInfo.carrierDate);
                carrierDate.setHours(hours, minutes, 0, 0); 
                let now = new Date();
   
                if (carrierDate < now) {
                    vueThis.$store.state.calculatorState = 'shippingInformationForm';
                    setTimeout(() => {
                        vueThis.$helper.toggleAccordion(6, true);
                    }, 500);        
                    return;     
                }
            }
     
            let valid = true;
            vueThis.transportCostsCheckError = false;
            vueThis.termsAndConditionsError = false;           

            let ajaxValidation = await vueThis.$helper.validate(['unregisteredCompanyInformation'], {unregisteredCompanyInformation: vueThis.$store.state.unregisteredCompanyInformation});
            if(!ajaxValidation){
                valid = false;
            }

            if(!vueThis.paymentAgreeCondition && vueThis.$store.state.$siteSettings.customer_payment_type !== 'all'){  
                vueThis.termsAndConditionsError = true;
                valid = false;
            }

            if(!vueThis.paymentAgreeTransportationCost && vueThis.$store.state.$siteSettings.customer_payment_type !== 'all'){  
                vueThis.transportCostsCheckError = true;               
                valid = false;
            }

            if(!valid){
               return; 
            }
    
            vueThis.requestInProgress = true;   
          
            if (vueThis.$store.state.selectedFormType === 'single') {              
                await vueThis.generateOrder();
            } else {
                await vueThis.generateOrders();
            }
        },
        generateOrder: async function() {
            let vueThis = this;  
            let url = vueThis.$store.state.$routes['paysera_create_payment'];

            let data = {
                    uniqueOrderNumber: vueThis.$store.state.uniqueOrderNumber,
                    paymentMethod: vueThis.$store.state.paymentOption,
                    unregisteredCompanyInformation: vueThis.$store.state.unregisteredCompanyInformation,
                    selectedFormType: vueThis.$store.state.selectedFormType,
                    // skip_paysera: vueThis.$store.state.$siteSettings['debug'],
                };
            
            axios.post(url, data)
                .then(function(response) {
                    vueThis.sendPurchaseDataLayer();              
                    window.location.replace(response.data);
                }).catch(function(error){
                    if(error.response.status === 400){
                        showToast(error.response.data, "#c91a13", 30000);
                    } else{
                        console.error(error);
                    }
                    vueThis.requestInProgress = false;
                });
        },
        generateOrders: async function() {
            let vueThis = this;  

            let url = vueThis.$store.state.$routes['paysera_create_payment'];
            let count = 1;
            let totalShipments = vueThis.$store.state.massShipments.length;
            const uniqueSessionId = vueThis.generateSessionId();
            
            for (const shipment of vueThis.$store.state.massShipments) {
                let status = count === totalShipments;

                let data = {
                    uniqueSessionId: uniqueSessionId,
                    uniqueOrderNumber: shipment.uniqueOrderNumber,
                    paymentMethod: vueThis.$store.state.paymentOption,
                    unregisteredCompanyInformation: vueThis.$store.state.unregisteredCompanyInformation,
                    selectedFormType: vueThis.$store.state.selectedFormType,
                    redirectTo: status
                };

                try {
                    const response = await axios.post(url, data);
                    if (response.data) {
                        vueThis.sendPurchaseDataLayer();
                        if (status) {
                            window.location.replace(response.data);
                        }
                    }
                } catch (error) {
                    if (error.response && error.response.status === 400) {
                        showToast(error.response.data, "#c91a13", 30000);
                    } else {
                        console.error(error);
                    }
                    vueThis.requestInProgress = false;
                }

                count++;
            }
        },
        generateSessionId: function () {           
            const randomString = Math.random().toString(36).substr(2, 10);  
            const timestamp = Date.now().toString(36);
            const sessionId = 'UPS_' + randomString + timestamp;

            return sessionId;
        },
        packageLineDimensions: function(packagesDimension){
            let text = `${packagesDimension.weight}kg`;
            if(this.$store.state.packageType !== '02'){
                return text;
            } 
            return text + ` (${packagesDimension.length}cm x ${packagesDimension.width}cm x ${packagesDimension.height}cm)`;
        },
        clickUnregisteredCompanyInformationRadio: function(type){
            if(this.$store.state.unregisteredCompanyInformation.type === type){
                this.$store.state.unregisteredCompanyInformation.type = '';
            }
            this.$forceUpdate();
        },
        checkDiscount: async function() {
            let vueThis = this;
            vueThis.wrongDiscountCode = false;

            let code = vueThis.$store.state.voucherCode;

            if (code === '') { 
                if (vueThis.needRestoreOldAmounts) {
                    vueThis.reCalculatePriceForDiscount(null); 
                    vueThis.needRestoreOldAmounts = false;
                } 
                return;
            }

            let url = vueThis.$store.state.$routes['api.check_discount_code_json'];

            await axios.post(url, {code:code}, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                if (!response.data.valid) {
                    vueThis.wrongDiscountCode = true;                
                    return;
                }

                vueThis.needRestoreOldAmounts = true;
                vueThis.reCalculatePriceForDiscount(response.data.impex_client_id, response.data.ups_api_account_id);                             
            }).catch(function(error){
                if(error.response.status == 422){
                    console.table(error.response.data);                
                }
            });
        },
        reCalculatePriceForDiscount: async function(impexClientId, upsApiAccountId, recursive = false) {
            let vueThis = this;            
            let customDiscounts = [];  
  
            vueThis.requestInProgress = true;  
            vueThis.$store.state.currentActions.gettingShippingOptions = true;          

            let url = vueThis.$store.state.$routes['api.get_shipping_options_json'];
            let data = {
                from: {
                    country: vueThis.$store.state.from.country,
                    postCode: vueThis.$store.state.from.postCode,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    country: vueThis.$store.state.to.country,
                    postCode: vueThis.$store.state.to.postCode,
                    city: vueThis.$store.state.deliveryAddressInformation.city,
                },
                impexClientId: impexClientId,
                upsApiAccountId: upsApiAccountId,
                customDiscounts,
                serviceCode: vueThis.$store.state.selectedShippingOption.serviceCode,
                orderNumber: vueThis.$store.state.uniqueOrderNumber,  
                voucherCode: vueThis.$store.state.voucherCode,              
                packageType: vueThis.$store.state.packageType,
                packages: vueThis.$store.state.packagesDimensions
            };          

            await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                if (impexClientId === null) {
                    vueThis.$store.state.selectedShippingOption = response.data.rate; 
                    vueThis.discountCodeDoesNotApply = false;

                    if (recursive) {
                        vueThis.discountCodeDoesNotApply = true;
                    }

                    return;
                } 

                if (response.data.detailed_cost.totalCostWithVat === 0) {
                    return vueThis.reCalculatePriceForDiscount(null, upsApiAccountId, true);
                }

                if (response.data.detailed_cost.totalCostWithVat < vueThis.$store.state.detailedCosts.totalCostWithVat) {
                    // vueThis.oldPrice = vueThis.$store.state.detailedCosts.totalCostWithVat;
                    vueThis.discountCodeDoesNotApply = false;
                    vueThis.$store.state.selectedShippingOption = response.data.rate; 
                    return;
                } 
                
                if (vueThis.oldPrice === 0) {
                    vueThis.oldPrice = 0;
                    vueThis.discountCodeDoesNotApply = true;                    
                    return;
                }                
                
            }).catch(function(error){
                if(error.response.status == 422){
                    console.table(error.response.data.errors);
                    alert('Formoje yra klaidų');
                }
            });
            
            await vueThis.sendRateShipmentRequestForDiscountAndUpdateOrder(impexClientId);            
        },
        sendRateShipmentRequestForDiscountAndUpdateOrder: async function(impexClientId) {
            let vueThis = this;

            if (vueThis.discountCodeDoesNotApply) {
                vueThis.$store.state.currentActions.gettingShippingOptions = false;
                vueThis.requestInProgress = false;  
                return;
            }

            let option = vueThis.$store.state.selectedShippingOption.serviceCode || '';

            let data = {
                from: {
                    ...vueThis.$store.state.from,
                    city: vueThis.$store.state.shipperAddressInformation.city,
                },
                to: {
                    ...vueThis.$store.state.to,
                    city: vueThis.$store.state.deliveryAddressInformation.city,
                },
                packages: vueThis.$store.state.packagesDimensions,
                shippingOptionCode: option.toString(),
                packageType: vueThis.$store.state.packageType,
                shipperAddressInformation: vueThis.$store.state.shipperAddressInformation,
                deliveryAddressInformation: vueThis.$store.state.deliveryAddressInformation,
                otherDeliveryInformation: vueThis.$store.state.otherDeliveryInformation,
                carrierInfo: vueThis.$store.state.carrierInfo,
                selectedShippingOption: vueThis.$store.state.selectedShippingOption,
                uploadedFiles: vueThis.$store.state.uploadedFiles,
                commercialInvoiceModal: vueThis.$store.state.commercialInvoiceModal,
                commercialInvoice: {
                    invoiceTotal: vueThis.$store.state.otherDeliveryInformation.invoiceTotal,
                    invoiceCurrency: vueThis.$store.state.otherDeliveryInformation.invoiceCurrency,
                },
                differentPaymentInformation: vueThis.$store.state.differentPaymentInformation,
                majorPaymentType: vueThis.$store.state.majorPaymentType,
                importInformation: vueThis.$store.state.importInformation,
                additionalAddressInfo: vueThis.$store.state.additionalAddressInfo,
                impexClientId: impexClientId,
                oldUniqueOrderNumber: vueThis.$store.state.uniqueOrderNumber,
            };      

            let url = vueThis.$store.state.$routes['api.get_rated_shipment_json'];
            await axios.post(url, data, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(function(response) {
                if (impexClientId === null) {
                    vueThis.oldPrice = 0;    
                } 

                if (response.data.detailedCosts.totalCostWithVat < vueThis.$store.state.detailedCosts.totalCostWithVat) {
                    vueThis.oldPrice = vueThis.$store.state.detailedCosts.totalCostWithVat;
                }

                vueThis.$store.state.detailedCosts = response.data.detailedCosts;
                vueThis.$store.state.uniqueOrderNumber = response.data.uniqueOrderNumber;
            }).catch(function(error) {           
                if(error.response.status == 422) {              
                    $.each(error.response.data.errors, function (indexInArray, valueOfElement) { 
                        showToast(valueOfElement, '#c91a13', 20000);                     
                    });
                } else if(error.response.status == 400) {         
                    if (error.response.data.PrimaryErrorCode !== undefined) {
                        showToast(error.response.data.PrimaryErrorCode.Description, '#c91a13', 20000);  
                    } else {
                        showToast(JSON.stringify(error.response.data), '#c91a13', 20000);  
                    }
                }
            }).finally(function(){
                vueThis.loading = false;
                if(vueThis.isEdit || vueThis.$store.state.inClientAdmin){
                    vueThis.reset = false;
                }
                vueThis.$store.state.currentActions.gettingShippingOptions = false;
                vueThis.requestInProgress = false;  
            });
        },
        getCalculatedPickupTime: function(shipment) {            
            return moment(shipment.service.estimatedPickup)
                .locale(this.$store.state.$siteSettings['current_lang'])
                .format(`L[, ${this.$helper.trans('until')}] LT`);
            
        },
        getFormattedDeliveryTime: function(shipment) {           
            return moment(shipment.service.estimatedDelivery)
                .locale(this.$store.state.$siteSettings['current_lang'])
                .format(`L[, ${this.$helper.trans('until')}] LT`)
                .replace('23:30', this.$helper.trans('end_of_work'));
        },
        getFullDeliveryAddress: function(shipment) {
            let address = shipment.Address1;
            if(shipment.Address2 !== '' && shipment.Address2 !== null){
                address += ' '+shipment.Address2;
            }
            if(shipment.Address3 !== '' && shipment.Address3 !== null){
                address += ' '+shipment.Address3;
            }

            return address;
        },
        sendPurchaseDataLayer: function() {
            let vueThis = this;

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'purchase',
                ecommerce: {
                    purchase: {
                        actionField:{
                            id: vueThis.$store.state.uniqueOrderNumber,
                            revenue: vueThis.$store.state.detailedCosts.totalCostWithVat,
                            shipping: 0,
                            paymentMethod: vueThis.$store.state.majorPaymentType,
                            tax: vueThis.$store.state.detailedCosts.vat,
                            payment: vueThis.$store.state.paymentOption,
                            delivery: vueThis.$store.state.selectedShippingOption.serviceName,
                        },
                        products: [
                            {
                                shippingService: vueThis.$store.state.selectShippingService,
                                packages: vueThis.$store.state.packagesDimensions,
                                from: {
                                    country: vueThis.$store.state.from.country,
                                    postCode: vueThis.$store.state.from.postCode,
                                    city: vueThis.$store.state.shipperAddressInformation.city,
                                },
                                to: {
                                    country: vueThis.$store.state.to.country,
                                    postCode: vueThis.$store.state.to.postCode,
                                    city: vueThis.$store.state.deliveryAddressInformation.city,
                                },
                                packagesType: vueThis.$store.state.packageType,
                            }
                        ]
                    }
                },
                enhanced_conversions: {
                    email: sha256(vueThis.$store.state.shipperAddressInformation.email).toString(),
                    phone: sha256(vueThis.$store.state.shipperAddressInformation.phone).toString(),
                }
            });
        },
    },    
    computed: {
        packageType(){
            let map = {
                '01': this.$helper.trans('Envelope'),
                '02': this.$helper.trans('Box'),
                '04': this.$helper.trans('UPS_Package'),
            };
            return map[this.$store.state.packageType] || '';
        },
        fullShipperAddress(){
            let address = this.$store.state.shipperAddressInformation.address1;
            if(this.$store.state.shipperAddressInformation.address2 !== '' && this.$store.state.shipperAddressInformation.address2 !== null){
                address += ' '+this.$store.state.shipperAddressInformation.address2;
            }
            if(this.$store.state.shipperAddressInformation.address3 !== '' && this.$store.state.shipperAddressInformation.address3 !== null){
                address += ' '+this.$store.state.shipperAddressInformation.address3;
            }
            return address;
        },
        fullDeliveryAddress(){
            let address = this.$store.state.deliveryAddressInformation.address1;
            if(this.$store.state.deliveryAddressInformation.address2 !== '' && this.$store.state.deliveryAddressInformation.address2 !== null){
                address += ' '+this.$store.state.deliveryAddressInformation.address2;
            }
            if(this.$store.state.deliveryAddressInformation.address3 !== '' && this.$store.state.deliveryAddressInformation.address3 !== null){
                address += ' '+this.$store.state.deliveryAddressInformation.address3;
            }
            return address;
        },
        calculatedPickupTime(){     
            if(this.isImport){
                return moment(this.$store.state.selectedShippingOption.estimatedPickup)
                    .locale(this.$store.state.$siteSettings['current_lang'])
                    .format(`L[, ${this.$helper.trans('until')}] LT`);
            }
            
            if(empty(this.$store.state.carrierInfo.callCarrier)){
                return this.$helper.trans('deliver_myself');
            }

            return `${this.$store.state.carrierInfo.carrierDate} ${this.$store.state.carrierInfo.carrierTimeFrom}-${this.$store.state.carrierInfo.carrierTimeTo}`;
        },
        formattedDeliveryTime(){ 
            return moment(this.$store.state.selectedShippingOption.estimatedDelivery)
                .locale(this.$store.state.$siteSettings['current_lang'])
                .format(`L[, ${this.$helper.trans('until')}] LT`)
                .replace('23:30', this.$helper.trans('end_of_work'));
        },
        transportPayerText(){
            let text = false;

            if(this.$store.state.majorPaymentType === 'prepaid'){
                return text;
            }

            if(this.$store.state.differentPaymentInformation.payer === 'receiver'){
                text = `${this.$helper.trans('Receiver_pays_transport')} ${this.$store.state.differentPaymentInformation.payerCode}`;
            } else if(this.$store.state.differentPaymentInformation.payer === 'third_party'){
                text = `${this.$helper.trans('Third_party_pays_transport')} ${this.$store.state.differentPaymentInformation.payerCountry.toUpperCase()} ${this.$store.state.differentPaymentInformation.payerCode}`;
            }

            return text;
        },
        taxPayerText(){
            let text = false;

            if(this.$store.state.majorPaymentType === 'prepaid' || this.$helper.insideEu() || this.$store.state.otherDeliveryInformation.isDocuments || this.$helper.isToIreland()){
                return text;
            }

            if(this.$store.state.differentPaymentInformation.payer !== 'sender' && this.$store.state.differentPaymentInformation.importPayer === 'sender'){
                return this.$helper.trans('SHIPPER_PAYS_DUTY_TAX');
            }

            if(this.$store.state.differentPaymentInformation.importPayer === 'receiver'){
                text = this.$helper.trans('Receiver_pays_tax');
                if(!empty(this.$store.state.differentPaymentInformation.importPayerCode)){
                    text += ' ' + this.$store.state.differentPaymentInformation.importPayerCode;
                }
            } else if(this.$store.state.differentPaymentInformation.importPayer === 'third_party'){
                text = `${this.$helper.trans('Third_party_pays_tax')} ${this.$store.state.differentPaymentInformation.importPayerCountry.toUpperCase()} ${this.$store.state.differentPaymentInformation.importPayerCode}`;
            }

            return text;
        },
        packageTypeName(){
            return (this.$store.state.packageType !== '04' ? this.packageType.toLowerCase() : this.packageType)
        },
        isImport(){
            return this.$store.state.to.country === 'lt';
        },        
    },
    watch: {
        '$store.state.paymentOption': function() {                          
            this.$helper.pushDataLayer(7);                
        }
    }
}
</script>
